import React from 'react';

import { cn } from '~/utils/styles';

interface LinkProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  underline?: 'always' | 'hover' | 'none';
  disabled?: boolean;
}

const Link = ({
  children,
  onClick,
  className,
  underline = 'hover',
  disabled = false,
}: LinkProps) => {
  const baseClasses = cn(
    'text-primary hover:text-primary-dark transition-colors',
    {
      underline: underline === 'always',
      'hover:underline': underline === 'hover',
      'cursor-pointer': onClick && !disabled,
      'cursor-not-allowed opacity-50': disabled,
    },
    className,
  );

  return (
    <span
      className={baseClasses}
      onClick={disabled ? undefined : onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick && !disabled ? 0 : undefined}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      {children}
    </span>
  );
};

export default Link;
